import { useState, useEffect } from 'react';
import { isMobileDevice } from '@/utils/pwa-utils';

/**
 * Hook para detectar si el usuario está en un dispositivo móvil de forma reactiva.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };

    window.addEventListener('resize', handleResize);
    // También detectar cambios de orientación
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return isMobile;
}
